import React from 'react';
import {
  Box,
  Flex,
  Image,
  Container,
  Heading,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  HStack,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import ivy from 'assets/ivy.webp';
import { FEATURES } from 'pages/landing/data/features';

function MeetIvy() {
  return (
    <>
      <Container maxW={'6xl'} pt={6}>
        <Stack spacing={4}>
          <Text
            textTransform={'uppercase'}
            color={'blue.400'}
            fontWeight={600}
            fontSize={'sm'}
            bg={useColorModeValue('blue.50', 'blue.900')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}
          >
            Meet Ivy
          </Text>
          <Heading fontSize={{ base: 'xl', sm: '2xl' }} fontWeight={'bold'}>
            Your AI-Powered Writing Tutor
          </Heading>
          <Stack direction="row" spacing={4}>
            <Box width={{ base: '25%', md: '15%', lg: '12%' }} p={4}>
              <Image
                rounded={'md'}
                alt={'feature image'}
                src={ivy}
                objectFit={'cover'}
              />
            </Box>
            <Box width={{ base: '75%', md: '85%', lg: '88%' }} p={4}>
              <Text color={'gray.500'} fontSize={'lg'}>
                Ivy doesn’t just assist—she empowers students by acting as a
                supportive tutor, not a writer. From sparking creativity to
                refining drafts, Ivy ensures students stay engaged and in
                control throughout the writing process.
              </Text>
            </Box>
          </Stack>
        </Stack>
      </Container>
      <Box p={4}>
        <Container maxW={'6xl'} mt={2}>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
            {FEATURES.map((feature) => (
              <HStack key={feature.id} align={'top'}>
                <Box>
                  <Flex
                    w={10}
                    h={10}
                    align={'center'}
                    justify={'center'}
                    color={'white'}
                    rounded={'full'}
                    bg={useColorModeValue('gray.100', 'gray.700')}
                  >
                    <Icon as={feature.icon} fontSize={24} />
                  </Flex>
                </Box>
                <VStack align={'start'}>
                  <Text fontWeight={600}>{feature.title}</Text>
                  <Text color={'gray.600'}>{feature.text}</Text>
                </VStack>
              </HStack>
            ))}
          </SimpleGrid>
        </Container>
      </Box>
    </>
  );
}

export default MeetIvy;
